
// import cmb1 from '../images/cmb1.jpg';

// function About() {
//   return (
//     <div className="container py-5">
//       <h1 className="text-center mb-5 text-white">About One Stop Service</h1>
//       <div className="row align-items-center">
//         <div className="col-lg-6 mb-4 mb-lg-0">
//           <img src={cmb1} alt="InstentRepair Team" className="img-fluid rounded shadow" />
//         </div>

//         <div className="col-lg-6 text-dark">
//           <h2>Our Story</h2>
//           <p>
//             Founded in 2024, <strong>One Stop Service</strong> started as a dedicated appliance repair company.
//             Over the years, we've grown into a full-service home improvement provider, offering not just appliance repairs, but also
//             <strong> painting, plumbing, deep cleaning, and other essential home services.</strong>
//           </p>
//           <p>
//             Our mission is simple: to make home maintenance easy, affordable, and dependable. Whether you need to fix a leaking pipe,
//             repaint a room, or deep clean your home, our expert technicians are here to help — on time and with lasting results.
//           </p>

//           <h2>Our Commitment</h2>
//           <ul>
//             <li>
//               <strong>All-in-One Solutions:</strong> Appliance repairs, plumbing, painting, cleaning, and more — all under one roof.
//             </li>
//             <li>
//               <strong>Quality Service:</strong> We use only high-quality parts and proven techniques to ensure long-term results.
//             </li>
//             <li>
//               <strong>Honest Pricing:</strong> Transparent, upfront quotes with no hidden charges.
//             </li>
//             <li>
//               <strong>Skilled Professionals:</strong> Every technician is trained, vetted, and customer-focused.
//             </li>
//             <li>
//               <strong>Flexible Scheduling:</strong> We respect your time and work around your availability.
//             </li>
//             <li>
//               <strong>Continuous Learning:</strong> We stay updated on the latest home service trends and technologies.
//             </li>
//           </ul>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default About;



import cmb1 from '../images/One3.jpg';

function About() {
  return (
    <div className="container py-5">
      <h1 className="text-center mb-5 rounded" style={{color:'#d4af37',backgroundColor:'#0b3d2e'}}>About OneStopService</h1>
      <div className="row align-items-center">
        <div className="col-lg-6 mb-4 mb-lg-0">
          <img src={cmb1} alt="One Stop Service Team" className="img-fluid rounded shadow" />
        </div>

        <div className="col-lg-6  text-dark">
          <h2 className=' rounded  text-center' style={{color:'#d4af37',backgroundColor:'#0b3d2e'}}>Our Story</h2>
          <p>
            Founded in 2024, <strong>One Stop Service</strong> began as a specialized appliance repair company. Built on a foundation of trust, 
            efficiency, and customer satisfaction, we quickly earned a reputation for reliability and quality work.
          </p>
          <p>
            As we listened to our customers’ needs, we expanded into a full-service home and lifestyle support provider. Our offerings now include 
            <strong> plumbing, painting, deep cleaning, electrical work</strong>, and most recently, <strong>professional web development</strong>.
          </p>
          <p>
            In today’s world, homes and businesses don't just exist in the physical space — they live online too. Our decision to branch into web development
            was fueled by a desire to support small businesses, freelancers, and startups in building their online presence with the same
            dedication we apply to our home services.
          </p>

          <h2 className=' rounded text-center' style={{color:'#d4af37',backgroundColor:'#0b3d2e'}}>Our Vision</h2>
          <p>
            Our vision is to become the most trusted name for both home improvement and digital growth services. Whether it's repairing what's broken,
            refreshing your space, or launching your online business — we aim to be your all-in-one solution partner.
          </p>

          <h2 className=' rounded  text-center' style={{color:'#d4af37',backgroundColor:'#0b3d2e'}}>What We Offer</h2>
          <ul>
            <li>
              <strong>Home Services:</strong> Appliance repairs, plumbing, painting, electrical work, and deep cleaning.
            </li>
            <li>
              <strong>Digital Services:</strong> Website design, development, hosting, SEO optimization, and maintenance.
            </li>
          </ul>

          <h2 className='rounded text-center' style={{color:'#d4af37',backgroundColor:'#0b3d2e'}}>Why Choose Us?</h2>
          <ul>
            <li>
              <strong>All-in-One Convenience:</strong> From fixing leaks to launching websites, we simplify your to-do list.
            </li>
            <li>
              <strong>High Standards:</strong> We use the best tools, tech, and techniques — in homes and in code.
            </li>
            <li>
              <strong>Transparent Pricing:</strong> No surprises. Clear, upfront quotes for every service.
            </li>
            <li>
              <strong>Qualified Experts:</strong> Certified technicians and experienced developers — all customer-focused.
            </li>
            <li>
              <strong>Reliable Support:</strong> Quick response times, easy scheduling, and consistent follow-ups.
            </li>
            <li>
              <strong>Innovation-Driven:</strong> We stay on top of trends, whether it’s smart home tech or modern web design.
            </li>
          </ul>

          <h2 className='rounded text-center' style={{color:'#d4af37',backgroundColor:'#0b3d2e'}}>Our Web Development Services</h2>
          <p>
            Whether you’re a small business owner, an entrepreneur, or someone with a passion project, our web development team brings your vision to life online.
          </p>
          <ul>
            <li><strong>Custom Website Design:</strong> Beautiful, user-friendly, responsive designs built to match your brand.</li>
            <li><strong>E-commerce Solutions:</strong> Online stores with secure payment integration and easy product management.</li>
            <li><strong>SEO Optimization:</strong> Improve visibility and ranking on search engines to attract more customers.</li>
            <li><strong>Website Maintenance:</strong> Regular updates, security checks, and support to keep your site running smoothly.</li>
            <li><strong>Hosting & Domain Support:</strong> Reliable and affordable hosting options with technical assistance.</li>
          </ul>
          <p>
            We blend creativity with functionality to deliver websites that look great and perform even better.
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
